// extracted by mini-css-extract-plugin
export default {"root":"XnqLO","header":"oAD19","headerContent":"UMTld","title":"Fxd79","scrollbar":"xr8YG","instruction":"RPAVl"};